




























































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { debounce, pick } from 'lodash';
import { Form } from '@ss/mtd-vue';
import TimeInput from './time-input.vue';
import { Sla2CN, SlaTip, SlaExplain, SlaSettingTip } from '@/config/map.conf';
import { formatTimeStr } from '@/utils/tool.ts';
import infoTip from '@/views/components/info-tip.vue';
import * as api from '@/api';

const validateSlaTime: Function = (_rule, value, callback) => {
    if (value > 0 && Number.isInteger(Number(value))) {
        return callback();
    }
    return callback(new Error('时长设置必须大于0分钟'));
};
const validateS5ResolveTime: Function = (_rule, value, callback) => {
    if ((value > 0 && Number.isInteger(Number(value))) || value === 'NONE') {
        return callback();
    }
    return callback(new Error('时长设置必须大于0分钟或为“NONE”'));
};
/**
 * SLA设置
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */
@Component({
    components: {
        TimeInput,
        infoTip
    }
})
export default class SlaConfig extends Vue {
    itemChangeHanler: Function = () => {};
    upgradeReasonRequire: boolean = false;
    form: any = {
        S1: {
            description: '',
            displayWhenLauch: false,
            resolve: {},
            response: {},
            assistRgs: []
        },
        S2: {
            description: '',
            displayWhenLauch: false,
            resolve: {},
            response: {},
            resolveWorkHour: {},
            responseWorkHour: {}
        },
        S3: {
            description: '',
            displayWhenLauch: false,
            resolve: {},
            response: {}
        },
        S4: {
            description: '',
            resolve: {},
            response: {}
        },
        S5: {
            description: '',
            displayWhenLauch: false,
            resolve: {},
            response: {}
        }
    };
    ruleCustom = {
        'S1.response.ruleValue': [{ validator: validateSlaTime, trigger: 'blur,change' }],
        'S1.resolve.ruleValue': [{ validator: validateSlaTime, trigger: 'blur,change' }],
        'S2.response.ruleValue': [{ validator: validateSlaTime, trigger: 'blur,change' }],
        'S2.resolve.ruleValue': [{ validator: validateSlaTime, trigger: 'blur,change' }],
        'S3.response.ruleValue': [{ validator: validateSlaTime, trigger: 'blur,change' }],
        'S3.resolve.ruleValue': [{ validator: validateSlaTime, trigger: 'blur,change' }],
        'S4.response.ruleValue': [{ validator: validateSlaTime, trigger: 'blur,change' }],
        'S4.resolve.ruleValue': [{ validator: validateSlaTime, trigger: 'blur,change' }],
        'S5.response.ruleValue': [{ validator: validateSlaTime, trigger: 'blur,change' }],
        'S5.resolve.ruleValue': [{ validator: validateS5ResolveTime, trigger: 'blur,change' }]
    };
    rgId: number = 0;
    slaConfigInfo: any = [];
    userList: any[] = [];
    checked: Boolean = false;
    assistRgs: string[] = [];
    sla2CN: CommonTypes.mapObject = Sla2CN;
    slaTip: CommonTypes.mapObject = SlaTip;
    slaExplain: CommonTypes.mapObject = SlaExplain;
    FormatTimeStr: Function = formatTimeStr;
    btnLoading: boolean = false;
    slaSettingTip: CommonTypes.mapObject = SlaSettingTip;

    $refs: { form: Form };

    created() {
        this.itemChangeHanler = debounce(this.settingsHandler, 500);
        this.rgId = parseInt(this.$route.query.rgId as string, 10);
        this.getSlaConfig();
    }
    async settingsHandler(item) {
        const propMap = ['rgId', 'name', 'slaUpgrade', 'displayWhenLauch', 'description'];
        const submitData = pick(this.form[item], propMap);
        if (item === 'S1') {
            const assistRgsList = await this.getAssistRgs();
            Object.assign(submitData, {
                assistRgs: {
                    items: assistRgsList
                }
            });
        }
        await api.rgApi.setRgConfig(submitData);
        this.$mtd.message({
            message: '设置SLA成功',
            type: 'success'
        });
    }
    async getSlaConfig() {
        try {
            const res = await api.rgApi.getSlaConfig(this.rgId);
            this.slaConfigInfo = res.data.items;
            this.upgradeReasonRequire = res.data.upgradeReasonRequire;
            this.initForm();
        } catch (e) {
            this.slaConfigInfo = [];
            console.log(e);
        }
    }
    async setSlaSharedSetting() {
        await api.rgApi.setSlaSharedSetting({
            rgId: this.rgId,
            upgradeReasonRequire: this.upgradeReasonRequire
        });
        this.$mtd.message({
            message: '设置SLA成功',
            type: 'success'
        });
    }
    // 初始化表单
    initForm() {
        Object.keys(this.form).forEach(key => {
            this.slaConfigInfo.forEach(item => {
                if (item.name === key) {
                    this.form[key] = item;
                }
            });
        });
        if (this.form.S1.assistRgs && this.form.S1.assistRgs.length) {
            this.assistRgs = this.form.S1.assistRgs.map(item => {
                return item.name;
            });
        }
        if (!(this.form.S2.resolveWorkHour && this.form.S2.responseWorkHour)) {
            const defaultResolve = this.form.S2.resolve;
            this.form.S2.resolveWorkHour = {
                ruleValue: defaultResolve.ruleValue,
                ruleUnit: defaultResolve.ruleUnit,
                ruleExpress: 'LE',
                ruleType: 'SLARESOLVEWORKHOUR'
            };
            const defaultResponse = this.form.S2.response;
            this.form.S2.responseWorkHour = {
                ruleValue: defaultResponse.ruleValue,
                ruleUnit: defaultResponse.ruleUnit,
                ruleExpress: 'LE',
                ruleType: 'SLARESPONSEWORKHOUR'
            };
        }
    }
    async remoteMethod(query) {
        try {
            const res = await api.rgApi.getRgList({ name: query });
            this.userList = res.data.items;
        } catch (e) {
            this.userList = [];
            console.log(e);
        }
    }
    redirect() {
        this.$router
            .push({
                name: 'my_rg'
            })
            .catch(e => e);
    }
    submit() {
        if (this.btnLoading) {
            return;
        }
        this.$refs.form
            .validate(async valid => {
                if (valid) {
                    this.btnLoading = true;
                    let assistRgsList = [];
                    try {
                        await api.rgApi.setSlaUpgrade({
                            name: 'S5',
                            rgId: (this.form.S5 as any).rgId,
                            slaUpgrade: this.form.S5.slaUpgrade
                        });
                        await api.rgApi.setSlaConfig(this.getConfigParams());
                        assistRgsList = await this.getAssistRgs();
                        await api.rgApi.setRgConfig({
                            name: this.form.S1.name,
                            rgId: this.rgId,
                            assistRgs: {
                                items: assistRgsList
                            }
                        });
                        this.$mtd.message({
                            message: '设置SLA成功',
                            type: 'success'
                        });
                        this.getSlaConfig();
                    } catch (e) {
                        console.log(e);
                    }
                    this.btnLoading = false;
                } else {
                    console.error('Fail!');
                }
            })
            .catch(e => e);
    }
    cancel() {
        this.$mtd
            .confirm({
                title: '确认放弃当前修改的内容吗？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确定',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    this.getSlaConfig();
                }
            })
            .catch(e => e);
    }
    // 获取协助rg
    async getAssistRgs() {
        await this.remoteMethod('');
        return this.userList
            .filter(item => {
                return this.assistRgs.indexOf(item.name) > -1;
            })
            .map(item => {
                return {
                    id: item.id,
                    name: item.name
                };
            });
    }
    getConfigParams() {
        const params: any[] = [];
        Object.keys(this.form).forEach(key => {
            const item = this.form[key];
            params.push({
                name: item.name,
                rgId: item.rgId,
                ruleType: 'SLARESOLVE',
                ruleValue: item.resolve.ruleValue,
                ruleUnit: item.resolve.ruleUnit,
                ruleExpress: 'LE'
            });
            params.push({
                name: item.name,
                rgId: item.rgId,
                ruleType: 'SLARESPONSE',
                ruleValue: item.response.ruleValue,
                ruleUnit: item.response.ruleUnit,
                ruleExpress: 'LE'
            });
            item.responseWorkHour &&
                params.push({
                    name: item.name,
                    rgId: item.rgId,
                    ruleType: 'SLARESPONSEWORKHOUR',
                    ruleValue: item.responseWorkHour.ruleValue,
                    ruleUnit: item.responseWorkHour.ruleUnit,
                    ruleExpress: 'LE'
                });
            item.resolveWorkHour &&
                params.push({
                    name: item.name,
                    rgId: item.rgId,
                    ruleType: 'SLARESOLVEWORKHOUR',
                    ruleValue: item.resolveWorkHour.ruleValue,
                    ruleUnit: item.resolveWorkHour.ruleUnit,
                    ruleExpress: 'LE'
                });
        });
        return params;
    }
}
